import { Navigate, Outlet } from 'react-router-dom'
import { Flex, Box } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { useAuth } from '../contexts/AuthContext'
import { brand } from '../theme'

const MotionBox = motion.create(Box)

export default function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return (
      <Flex minH="100vh" alignItems="center" justifyContent="center" bg="#F7F8F6">
        <MotionBox
          width="40px"
          height="40px"
          borderRadius="full"
          border="3px solid"
          borderColor={`${brand.green}33`}
          borderTopColor={brand.green}
          animate={{ rotate: 360 }}
          transition={{ duration: 0.8, repeat: Infinity, ease: 'linear' }}
        />
      </Flex>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}
